import { render, staticRenderFns } from "./StockInInfo.vue?vue&type=template&id=6b94df67&scoped=true&"
import script from "./StockInInfo.vue?vue&type=script&lang=js&"
export * from "./StockInInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94df67",
  null
  
)

export default component.exports